export default function EFCoffeeMaker(props: any) {
    return (
        <svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Coffee-Maker-_icon@1x">
                    <rect id="矩形" x="0" y="0" width="30" height="30"></rect>
                    <g id="编组-44" strokeLinejoin="round" transform="translate(3.000000, 3.000000)" stroke="#FFFFFF" strokeWidth="0.96">
                        <path d="M0,24 L9.6345663,24 L9.6345663,0 L6.68660182,0 C2.99377291,0 0,3.01104 0,6.72624 L0,24 Z" id="Stroke-85"></path>
                        <path
                            d="M17.196539,2.135136 L9.63480488,2.135136 L9.63480488,7.837056 L20.5114481,7.837056 L20.5114481,5.469696 C20.5114481,3.627936 19.0274453,2.135136 17.196539,2.135136 Z"
                            id="Stroke-86"
                        ></path>
                        <path
                            d="M21.6819017,20.4096 L9.63475718,20.4096 L9.63475718,24 L24,24 L24,22.74144 C24,21.4536 22.9621523,20.4096 21.6819017,20.4096 Z"
                            id="Stroke-87"
                        ></path>
                        <path
                            d="M19.8135374,17.066256 C19.8135374,18.820176 18.4001559,20.241936 16.6565719,20.241936 C14.9129878,20.241936 13.4996063,18.820176 13.4996063,17.066256 L13.4996063,14.946096 L19.8135374,14.946096 L19.8135374,16.505136 L19.8135374,17.066256 Z"
                            id="Stroke-88"
                        ></path>
                        <line x1="22.0873064" y1="16.55016" x2="19.813585" y2="16.55016" id="Stroke-89" strokeLinecap="round"></line>
                        <polygon id="Stroke-90" points="15.2257736 10.336272 17.7104048 10.336272 17.7104048 7.836912 15.2257736 7.836912"></polygon>
                        <line x1="3.1024107" y1="3.95952" x2="6.72168805" y2="3.95952" id="Stroke-91" strokeLinecap="round"></line>
                        <line x1="3.1024107" y1="6.106416" x2="6.72168805" y2="6.106416" id="Stroke-92" strokeLinecap="round"></line>
                        <path
                            d="M6.72168805,16.617408 C6.72168805,17.6229868 5.91170231,18.4377742 4.91204937,18.4377742 C3.91280696,18.4377742 3.1024107,17.6229868 3.1024107,16.617408 C3.1024107,15.6118291 3.91280696,14.7970418 4.91204937,14.7970418 C5.91170231,14.7970418 6.72168805,15.6118291 6.72168805,16.617408 Z"
                            id="Stroke-93"
                            strokeLinecap="round"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}
